import config from './config';

/**
 * Sitemap configuration for the SiteMapService.
 *
 * Controls sitemap generation behavior including API interaction limits.
 */
const sitemap = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /** Environment string used to distinguish environments for the sitemap. */
      environment: { default: 'beta', prod: 'prod' },

      /** Brand designation, should reflect the sitemap brand. */
      brand: undefined as unknown as string,

      /**
       * Maximum products per API request when fetching category products.
       * Most commerce APIs limit batch size; 200 is a safe default (SFCC).
       */
      productBatchSize: 200,

      /**
       * Maximum concurrent category fetches.
       * Limits parallel requests to avoid overwhelming the backend.
       * 15 is a good balance between speed and not overloading SFCC.
       */
      maxConcurrentCategories: 15,

      /**
       * Maximum URLs per sitemap segment.
       * Google's limit is 50,000 URLs per sitemap file.
       *
       * @see https://developers.google.com/search/docs/crawling-indexing/sitemaps/build-sitemap#sitemapformat
       */
      urlsPerSegment: 50000,

      /**
       * Cache TTL settings for sitemap data.
       *
       * @see ITTLSpec for how these values are used.
       */
      cache: {
        /** Fresh period in hours. After this, stale-while-revalidate kicks in. */
        freshTTLInHours: { default: 24, dev: 1 },

        /** SWR period in hours. Stale data served while revalidating in background. */
        swrTTLInHours: { default: 24 * 7, dev: 1 }, // 7 days

        /** Error cache period in minutes. How long to cache errors before retrying. */
        errorTTLInMinutes: { default: 5, dev: 1 },

        /** Stale-if-error period in hours. Serve stale data instead of errors. */
        staleIfErrorTTLInHours: { default: 24, dev: 1 }
      }
    }
  },
  'AHNU-US': { default: { brand: 'ahnu' } },
  'TEVA-US': { default: { brand: 'teva' } }
});

export default sitemap;
